export async function apiCall( url: string, options: any = {}, errorMsg: string = '', returnFormat: 'json' | 'text' | 'response' = 'json' ) {
	const callResponse = await fetch( `/api/${ url }`, options );

	if ( !callResponse.ok ) {
		throw new Error( errorMsg || `There was an error calling this endpoint: ${ url }` );
	}

	switch ( returnFormat ) {
		case 'json': {
			return callResponse.json();
		}

		case 'text': {
			return callResponse.text();
		}

		case 'response': {
			return callResponse;
		}
	}
}
